import { CheckCircle2 } from "lucide-react";
import { formatCHF } from "@/lib/api";
import { longDate } from "@/components/stage-reservation/IndividualCalendar";

export const Confirmation = ({ booking }) => {
  const jour = booking.date_individuelle ? new Date(`${booking.date_individuelle}T12:00:00`) : new Date(booking.event_date);
  return (
    <div className="border border-sage/40 bg-sage-light/40 p-8 sm:p-10 text-center" data-testid="stage-confirmation">
      <CheckCircle2 className="w-12 h-12 text-sage mx-auto mb-4" />
      <p className="font-serif text-3xl text-bark">Votre réservation est enregistrée</p>
      <p className="text-fumee mt-3 max-w-lg mx-auto leading-relaxed">
        Référence <span className="font-mono text-terra" data-testid="stage-confirmation-reference">{booking.reference}</span> · {booking.event_titre} · <span className="capitalize">{longDate(jour)}</span> · {booking.participants} participant·e{booking.participants > 1 ? "·s" : ""} · <span data-testid="stage-confirmation-total">{formatCHF(booking.montant_du ?? booking.montant)}</span>
        {booking.paiement === "facture" ? " · facture payable sous 10 jours" : booking.paiement === "carte_cadeau" ? " · réglé par carte cadeau" : ""}.
      </p>
      {booking.date_a_confirmer && <p className="text-sm text-terra mt-3" data-testid="stage-confirmation-date-pending">La date vous sera confirmée par Ludovic sous 48 h.</p>}
      {(booking.tambours || []).map((t) => <p key={t.numero} className="text-xs font-mono text-terra mt-2">Tambour {t.numero} : {t.resume}</p>)}
      <p className="text-sm text-fumee mt-4">Un e-mail de confirmation est envoyé à {booking.email}.</p>
    </div>
  );
};
